import Crud from '../components/User/Crud'
import User from '../components/User/User'

let routes = {
    path: '/users',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/users',
            name: 'Usuários',
            component: Crud
        },
        {
            path: '/user/:id?',
            name: 'Usuário',
            component: User
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/user.js